import { Component, OnInit } from '@angular/core';
import { SearchFieldType, SearchFieldCategories } from 'src/search/models/search-field-type.enum';
import { SearchResource } from 'src/search/services/search.resource';
import { SEARCH_FIELD_SPEC } from '../../models/search-field-type-spec';
import { Router } from '@angular/router';
import { LoadingIndicatorService } from 'src/infrastructure/loading-indicator.service';
import { SearchField } from 'src/search/models/search-field';
import * as QueryBuilder from 'src/search/services/logical-operator-query-builder.service';
import { SearchState } from 'src/search/services/search.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'search-categories',
  templateUrl: './search-categories.component.html',
  styleUrls: ['./search-categories.component.scss']
})
export class SearchCategoriesComponent implements OnInit {

  constructor(
    private resource: SearchResource,
    private router: Router,
    private loadingIndicator: LoadingIndicatorService,
    private state: SearchState
  ) {
    this.loading = this.loadingIndicator.change$;
  }

  categoryData: any = {};
  SEARCH_FIELD_SPEC = SEARCH_FIELD_SPEC;
  SearchFieldType = SearchFieldType;
  categories = SearchFieldCategories;
  loading: Observable<boolean>;

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {
    let aggregationsQuery = QueryBuilder.buildAggregations([]);
    this.loadingIndicator.start();
    this.resource.search(null, aggregationsQuery)
      .subscribe(res => {
        this.categories
          .forEach(category => this.categoryData[SEARCH_FIELD_SPEC[category].name] = this.removeEmpty(res.categories[SEARCH_FIELD_SPEC[category].name]))
        //this.categoryData = res.categories;
        this.loadingIndicator.stop();
      }, () => this.loadingIndicator.stop());
  }

  removeEmpty(category) {
    return category;
    //return category.filter(item => item.count);
  }

  selectCategory(category: SearchFieldType, value: any) {
    this.state.change$.next({
      q: [{
        ...new SearchField(category, value.key),
        controlMetadata: {
          model: value
        }
      }]
    });

    this.router.navigate(['/search']);
  }
}
